export default "__VITE_ASSET__CCZ$00Jj__"